import apiClient, { safeJson } from '@/api/client';
import { ChangeLogListResponse, ChangeLogTargetType } from './types';

/**
 * 수강권(PT/그룹) 변경이력 조회.
 * targetId(수강권/멤버티켓 _id) 단위로 고유하므로 centerId 는 보내지 않는다
 * (레거시 centerId=null 로그가 필터에서 제외되는 것을 방지).
 */
export const getMembershipChangeLogs = async (params: {
    targetType: ChangeLogTargetType;
    targetId: string;
    memberId?: string;
    includeSystem?: boolean;
    page?: number;
    limit?: number;
}) => {
    const searchParams: Record<string, string> = {
        targetType: params.targetType,
        targetId: params.targetId,
    };
    if (params.memberId) searchParams.memberId = params.memberId;
    if (params.includeSystem) searchParams.includeSystem = 'true';
    searchParams.page = String(params.page ?? 1);
    searchParams.limit = String(params.limit ?? 200);

    const res = await apiClient.get('v1/membership-change-logs', { searchParams });
    return { status: res.status, data: (await safeJson(res)) as ChangeLogListResponse | null };
};
